export const attributes = {
  titleDe: {
    label: 'Titel - Deutsch',
    name: 'titleDe',
  },
  titleRu: {
    label: 'Titel - Russisch',
    name: 'titleRu',
  },
};
export interface ITrailerTypeDocument {
  id?: number;
  titleDe: string;
  titleRu: string;
}

export class TrailerType implements ITrailerTypeDocument {
  titleDe = '';

  titleRu = '';
}
